import React from "react";
import { useState, useEffect } from "react";
import api from "../../api";
import Dropzone from "react-dropzone";
import { toast } from "sonner";
import { useGlobalContext } from "../../context";
import UserSideNav from "../components/UserSideNav";
import spinner from "../../images/Spinnergrey.svg";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut, BiSolidWallet } from "react-icons/bi";
import userDashLinks from "./userDashLinks";
import { LuUpload } from "react-icons/lu";

const UserKyc = () => {
  const { allUserMongoData } = useGlobalContext();

  const [navActive, updateNavActive] = useState(null);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const clearSess = async () => {
    try {
      await api.post("/api/logout");
    } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => {
    updateNavActive(false);
  };

  const [, setIdImages] = useState([]);
  const [selectedIdImages, setSelectedIdImages] = useState([]);

  const [, setPassImages] = useState([]);
  const [selectedPassImages, setSelectedPassImages] = useState([]);

  const handleIdDrop = (acceptedIdFiles) => {
    setIdImages((prev) => [...prev, ...acceptedIdFiles]);
    setSelectedIdImages((prev) => [...prev, ...acceptedIdFiles]);
  };

  const handlePassDrop = (acceptedPassFiles) => {
    setPassImages((prev) => [...prev, ...acceptedPassFiles]);
    setSelectedPassImages((prev) => [...prev, ...acceptedPassFiles]);
  };

  const [isLoadingBtn, updateisLoadingBtn] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const submitKYC = async () => {
    updateisLoadingBtn(true);
    setIsButtonDisabled(true);

    try {
      const formData = new FormData();
      selectedIdImages.forEach((image, index) => {
        formData.append(`idImages${index}`, image);
      });
      selectedPassImages.forEach((image, index) => {
        formData.append(`passPortImages${index}`, image);
      });

      const response = await api.post("/api/user/kyc", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const KycData = response.data;

      if (KycData.errMsg) {
        toast.error(KycData.errMsg);
        updateisLoadingBtn(false);
        setIsButtonDisabled(false);
        setSelectedPassImages([]);
        setSelectedIdImages([]);
      } else {
        toast.success(KycData.successMsg);
        updateisLoadingBtn(false);
        setSelectedPassImages([]);
        setSelectedIdImages([]);
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error submitting KYC:", error);
      updateisLoadingBtn(false);
      setIsButtonDisabled(false);
      setSelectedPassImages([]);
      setSelectedIdImages([]);
      toast.error("An error occurred while submitting KYC, contact support.");
    }
  };

  const kycStatus = allUserMongoData?.kycStatus || 'unverified';
  const kycRejectedAt = allUserMongoData?.kycRejectedAt;
  const KYC_COOLDOWN_DAYS = 4;

  const daysUntilResubmit = () => {
    if (!kycRejectedAt) return 0;
    const diff = Date.now() - new Date(kycRejectedAt).getTime();
    const daysPassed = diff / (1000 * 60 * 60 * 24);
    return Math.max(0, Math.ceil(KYC_COOLDOWN_DAYS - daysPassed));
  };

  const canResubmit = kycStatus === 'rejected' && daysUntilResubmit() === 0;
  const showForm = kycStatus === 'unverified' || canResubmit;

  return (
    <div className="absolute overflow-hidden w-full min-h-full text-white bg-black">
      <UserSideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={
          navActive ? `translate-x-[0px]` : `translate-x-[-500px]`
        }
        clearSess={clearSess}
        backgroundColor="bg-black"
        arrowCoLor="text-white"
        iconBorderColor="border-white"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={userDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1]" />
        }
      />

      {navActive && (
        <div
          className="fixed inset-0 bg-black/60 z-40 xl:hidden"
          onClick={hideNav}
        />
      )}

      <div className="relative w-full h-full p-4 overflow-hidden mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button
              onClick={() => updateNavActive(true)}
              className="relative xl:hidden"
            >
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>

            <div className="relative flex space-x-2">
              <div className="relative flex justify-center items-center space-x-2 min-h-[38px] py-2 px-4 bg-[#181C26] border border-[#1f2535] rounded-lg transition-all ease-in duration-200 hover:border-[#473ECD]">
                <BiSolidWallet className="text-[14px] text-[#A9ABAD]" />
                <p className="text-[12px] text-[#A9ABAD]">
                  $
                  {allUserMongoData && allUserMongoData.balance
                    ? allUserMongoData.balance.toLocaleString()
                    : "0"}
                </p>
              </div>
            </div>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">
            Identity Verification
          </h3>
          <p className="text-[#A9ABAD] text-[14px]">
            Upload your documents to verify your account.
          </p>
        </div>

        {/* verified state */}
        {kycStatus === 'verified' && (
          <div className="w-full sm:w-[480px] bg-[#181C26] border border-[#1f2535] rounded-xl p-6 flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <span className="w-[8px] h-[8px] rounded-full bg-green-500 inline-block"></span>
              <p className="text-[14px] font-[600] text-white">Identity Verified</p>
            </div>
            <p className="text-[13px] text-[#A9ABAD]">Your account has been successfully verified.</p>
          </div>
        )}

        {/* pending state */}
        {kycStatus === 'pending' && (
          <div className="w-full sm:w-[480px] bg-[#181C26] border border-[#1f2535] rounded-xl p-6 flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <span className="w-[8px] h-[8px] rounded-full bg-yellow-400 inline-block"></span>
              <p className="text-[14px] font-[600] text-white">Under Review</p>
            </div>
            <p className="text-[13px] text-[#A9ABAD]">Your documents have been submitted and are currently being reviewed. You will be notified once the process is complete.</p>
          </div>
        )}

        {/* rejected cooldown state */}
        {kycStatus === 'rejected' && daysUntilResubmit() > 0 && (
          <div className="w-full sm:w-[480px] bg-[#181C26] border border-red-900/40 rounded-xl p-6 flex flex-col space-y-2">
            <div className="flex items-center space-x-2">
              <span className="w-[8px] h-[8px] rounded-full bg-red-500 inline-block"></span>
              <p className="text-[14px] font-[600] text-white">Verification Unsuccessful</p>
            </div>
            <p className="text-[13px] text-[#A9ABAD]">Your KYC submission was not approved. You can resubmit in <span className="text-white font-[500]">{daysUntilResubmit()} day{daysUntilResubmit() !== 1 ? 's' : ''}</span>.</p>
          </div>
        )}

        {/* upload form */}
        {showForm && (
          <div className="w-full flex flex-col space-y-4 sm:w-[480px]">
            {canResubmit && (
              <div className="w-full bg-[#181C26] border border-[#1f2535] rounded-xl px-5 py-3">
                <p className="text-[12px] text-[#A9ABAD]">Your previous submission was not approved. Please resubmit your documents.</p>
              </div>
            )}

            {/* ID document upload */}
            <div className="w-full bg-[#181C26] border border-[#1f2535] rounded-xl p-6 flex flex-col space-y-4">
              <div>
                <p className="text-[13px] font-[500] text-white">
                  Government-issued ID
                </p>
                <p className="text-[12px] text-[#A9ABAD] mt-1">
                  Driver's license, international passport, or any
                  government-approved document.
                </p>
              </div>

              <Dropzone
                onDrop={handleIdDrop}
                accept="image/jpeg, image/png, image/jpg, image/webp"
                multiple
              >
                {({ getRootProps, getInputProps }) => (
                  <div
                    {...getRootProps()}
                    className="w-full min-h-[100px] flex flex-col justify-center items-center space-y-2 border border-dashed border-[#2e3340] rounded-lg p-4 cursor-pointer transition-colors hover:border-[#473ECD] hover:bg-[#0d1017]"
                  >
                    <input {...getInputProps()} />
                    <LuUpload className="text-[#A9ABAD] text-[20px]" />
                    <p className="text-[12px] text-[#A9ABAD] text-center">
                      Drag & drop or{" "}
                      <span className="text-[#473ECD]">click to upload</span>
                    </p>
                    <p className="text-[11px] text-[#535963]">
                      JPG, PNG, WEBP supported
                    </p>
                  </div>
                )}
              </Dropzone>

              {selectedIdImages.length > 0 && (
                <div className="flex items-center space-x-3 flex-wrap gap-y-2">
                  <p className="text-[12px] text-[#A9ABAD]">Selected:</p>
                  {selectedIdImages.map((image, index) => (
                    <img
                      key={index}
                      src={URL.createObjectURL(image)}
                      alt="ID"
                      className="w-[52px] h-[52px] rounded-lg object-cover border border-[#1f2535]"
                    />
                  ))}
                </div>
              )}
            </div>

            {/* Passport photo upload */}
            <div className="w-full bg-[#181C26] border border-[#1f2535] rounded-xl p-6 flex flex-col space-y-4">
              <div>
                <p className="text-[13px] font-[500] text-white">
                  Passport Photographs
                </p>
                <p className="text-[12px] text-[#A9ABAD] mt-1">
                  Upload two recent passport-size photographs.
                </p>
              </div>

              <Dropzone
                onDrop={handlePassDrop}
                accept="image/jpeg, image/png, image/jpg, image/webp"
                multiple
              >
                {({ getRootProps, getInputProps }) => (
                  <div
                    {...getRootProps()}
                    className="w-full min-h-[100px] flex flex-col justify-center items-center space-y-2 border border-dashed border-[#2e3340] rounded-lg p-4 cursor-pointer transition-colors hover:border-[#473ECD] hover:bg-[#0d1017]"
                  >
                    <input {...getInputProps()} />
                    <LuUpload className="text-[#A9ABAD] text-[20px]" />
                    <p className="text-[12px] text-[#A9ABAD] text-center">
                      Drag & drop or{" "}
                      <span className="text-[#473ECD]">click to upload</span>
                    </p>
                    <p className="text-[11px] text-[#535963]">
                      JPG, PNG, WEBP supported
                    </p>
                  </div>
                )}
              </Dropzone>

              {selectedPassImages.length > 0 && (
                <div className="flex items-center space-x-3 flex-wrap gap-y-2">
                  <p className="text-[12px] text-[#A9ABAD]">Selected:</p>
                  {selectedPassImages.map((image, index) => (
                    <img
                      key={index}
                      src={URL.createObjectURL(image)}
                      alt="passport"
                      className="w-[52px] h-[52px] rounded-lg object-cover border border-[#1f2535]"
                    />
                  ))}
                </div>
              )}
            </div>

            {/* submit */}
            <button
              disabled={isButtonDisabled}
              onClick={() => submitKYC()}
              className="w-full min-h-[44px] flex justify-center items-center space-x-2 text-[14px] font-[500] bg-userDashPurple rounded-lg transition-all ease-in duration-200 hover:bg-[#3d34b5] disabled:opacity-60"
            >
              {isLoadingBtn ? (
                <img src={spinner} className="w-[22px] h-[22px]" alt="loading" />
              ) : (
                "Submit for Verification"
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserKyc;
